angular.module('app.shared.password.passwordService', [])
  .factory('app.shared.password.passwordService', [
    function () {
      "use strict";

      return {
        new: () => {
          let checker = {
            requirements: {
              passwordRequired: {
                description: 'Password is required. / Mot de passe requis',
                value: true,
                passed: false
              },
              minLength: {
                description: 'Password must be at least 8 characters. / Mot de passe doit contenir 8 caractères',
                value: 8,
                passed: false
              },
              lowerCase: {
                description: 'Password must contain at least one lower case letter. / Mot de passe doit contenir au moins une lettre minuscule',
                value: true,
                passed: false
              },
              upperCase: {
                description: 'Password must contain at least one upper case letter. / Mot de passe doit contenir au moins une lettre majuscule',
                value: true,
                passed: false
              },
              number: {
                description: 'Password must contain at least one number. / Mot de passe doit contenir au moins 1 chiffre',
                value: true,
                passed: false
              },
              symbol: {
                description: 'Password must contain at least one symbol. / Mot de passe doit contenir au moins 1 symbole',
                value: true,
                passed: false
              }
            },
            passwordStrength: (password) => {
              if (checker.validate(password)) {
                return 1;
              }
              else {
                let strength = 0;
                let maxStrength = 0;

                _.forEach(checker.requirements, (requirement) => {
                  if (requirement.value) {
                    maxStrength++;

                    if(requirement.passed){
                      strength++;
                    }
                  }
                });

                return strength / maxStrength;
              }
            },
            validate: (password) => {
              if (!password) {
                password = '';
              }

              checker.requirements.passwordRequired.passed = !(checker.requirements.passwordRequired.value && !password);

              checker.requirements.minLength.passed = password.length >= checker.requirements.minLength.value;

              checker.requirements.lowerCase.passed = true;
              if(checker.requirements.lowerCase.value) {
                if (!password.match(/[a-z]/)) {
                  checker.requirements.lowerCase.passed = false;
                }
              }

              checker.requirements.upperCase.passed = true;
              if (checker.requirements.upperCase.value) {
                if (!password.match(/[A-Z]/)) {
                  checker.requirements.upperCase.passed = false;
                }
              }

              checker.requirements.number.passed = true;
              if (checker.requirements.number.value) {
                if (!password.match(/[0-9]/)) {
                  checker.requirements.number.passed = false;
                }
              }

              checker.requirements.symbol.passed = true;
              if (checker.requirements.symbol.value) {
                let regex = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/);
                if (!password.match(regex)) {
                  checker.requirements.symbol.passed = false;
                }
              }

              let isValid = true;
              _.forEach(checker.requirements, (requirement) => {
                if (requirement.value && !requirement.passed) {
                  isValid = false;
                  return false;
                }
              });
              return isValid;
            }
          };

          return checker;
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/password/passwordService.js